<template>
  <div class="pay-confirm">
    <div class="pay-confirm-form">
      <van-form label-width="100px">
        <van-field
          v-model="storeInfo.medicine_count"
          name="药品数量"
          label="药品数量:"
          placeholder="请输入"
          type="digit"
          :rules="[{ required: true, message: '请填写药品单价' }]"
          @change="payInfoChange"
        >
          <template #button>
            瓶
          </template>
        </van-field>
        <van-field
          v-if="pd1EnumsMap.jiesuan_typeArr"
          name="radio"
          label="结算方式:"
        >
          <template #input>
            <van-radio-group
              v-model="storeInfo.jiesuan_type"
              direction="horizontal"
              @change="payInfoChange"
            >
              <van-radio
                v-for="item in pd1EnumsMap.jiesuan_typeArr.filter((item) => {
                  if (!storeInfo.channel_type) return item.value !== 1;
                  return true
                })"
                :name="item.value"
                :key="item.value"
              >{{ item.name }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          name="radio"
          label="医保报销比例:"
        >
          <template #input>
            {{ Number.isFinite(paymentInfo.yibao_baoxiao_ratio) ? `${paymentInfo.yibao_baoxiao_ratio}%` : '' }}
          </template>
        </van-field>
        <van-field
          name="radio"
          label="圆和报销比例:"
        >
          <template #input>
            {{ Number.isFinite(paymentInfo.yuanhe_baoxiao_ratio) ? `自付费用的${paymentInfo.yuanhe_baoxiao_ratio}%` : '' }}
          </template>
        </van-field>
      </van-form>
      <div class="pay-confirm-amount">
        <van-form label-width="100px">

          <van-field
            name="radio"
            label="垫付金额:"
          >
            <template #input>
              {{ Number.isFinite(paymentInfo.dianfu_money) ? `${paymentInfo.dianfu_money}元` : '' }}
            </template>
          </van-field>
          <van-field
            name="radio"
            label="自付金额："
          >
            <template #input>
              {{ Number.isFinite(paymentInfo.zifu_money) ? `${paymentInfo.zifu_money}元` : '' }}
            </template>
          </van-field>
        </van-form>
      </div>
    </div>
    <div class="pay-confirm-btn">
      <el-button
        type="info"
        @click="previousStep"
      >上一步</el-button>
      <el-button
        type="primary"
        @click="confirm"
        :disabled="uploading"
      >确认</el-button>
    </div>
  </div>

</template>

<script>
import { getStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";
import { Message } from "element-ui";
import enums from "@/views/pd1/mixins/enums";
import pd1Service from "@/apis/pd1/index.js";

export default {
  data() {
    return {
      form: {},
      storeInfo: {},
      paymentInfo: {},
      uploading: false,
    };
  },

  mixins: [enums],

  methods: {
    init() {
      const storeInfo = getStorageExpire(CONFIG_STORAGE.PD1_STORE);
      this.storeInfo = storeInfo;
      if (!storeInfo?.id) {
        Message({
          message: "请先选择门店",
          type: "warning",
        });
        this.$router.replace({
          name: "Pd1PharmacyFinder",
          query: {
            ...this.$route.query,
          },
        });
        return;
      }
    },
    payInfoChange() {
      const { storeInfo } = this;
      if (storeInfo.medicine_count && storeInfo.jiesuan_type) {
        pd1Service
          .calculateAdvancePayment({
            ...storeInfo,
            drugstore_id: storeInfo.drugInfo.drugstore_id,
            medicine_id: storeInfo.drugInfo.id,
            work_id: this.$route.query.work_id,
          })
          .then((res) => {
            this.paymentInfo = res;
          });
      }
    },
    confirm() {
      const { storeInfo, currentUserInfo, paymentInfo } = this;
      if (!paymentInfo.zifu_money) {
        Message({
          message: "请先填写药品单价及结算方式",
          type: "warning",
        });
        return;
      }
      const params = {
        ...storeInfo,
        ...paymentInfo,
        confirm_status: 2,
        drugstore_id: storeInfo.drugInfo.drugstore_id,
        medicine_id: storeInfo.drugInfo.id,
        work_id: this.$route.query.work_id,
        ding_user_id: currentUserInfo.user_id,
      };
      this.uploading = true;
      pd1Service
        .progressButieStep2_Dianfu(params)
        .then(() => {
          this.uploading = false;
          Message({
            message: "确认成功",
            type: "success",
          });
          this.$router.go(-2);
        })
        .catch(() => {
          this.uploading = false;
        });
    },
    previousStep() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-confirm {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pay-confirm-amount {
  margin-top: 100px;
}
.pay-confirm-btn {
  padding: 0 20px;
  .el-button {
    width: 100%;
    margin-bottom: 20px;
    margin-left: 0;
  }
}
</style>